export default {
      id: "pending-usage",
      viewBox: "0 0 64 64",
      url: __webpack_public_path__ + "sprite.svg#pending",
      toString: function () {
        return this.url;
      }
    }